export default {
  name: 'he',
  el: {
    colorpicker: {
      confirm: 'אישור',
      clear: 'נקה',
    },
    datepicker: {
      now: 'כעת',
      today: 'היום',
      cancel: 'בטל',
      clear: 'נקה',
      confirm: 'אישור',
      selectDate: 'בחר תאריך',
      selectTime: 'בחר זמן',
      startDate: 'תאריך התחלה',
      startTime: 'זמן התחלה',
      endDate: 'תאריך סיום',
      endTime: 'זמן סיום',
      prevYear: 'שנה קודמת',
      nextYear: 'שנה הבאה',
      prevMonth: 'חודש קודם',
      nextMonth: 'חודש הבא',
      year: 'שנה',
      month1: 'ינואר',
      month2: 'פברואר',
      month3: 'מרץ',
      month4: 'אפריל',
      month5: 'מאי',
      month6: 'יוני',
      month7: 'יולי',
      month8: 'אוגוסט',
      month9: 'ספטמבר',
      month10: 'אוקטובר',
      month11: 'נובמבר',
      month12: 'דצמבר',
      week: 'שבוע',
      weeks: {
        sun: 'א׳',
        mon: 'ב׳',
        tue: 'ג׳',
        wed: 'ד׳',
        thu: 'ה׳',
        fri: 'ו׳',
        sat: 'שבת',
      },
      months: {
        jan: 'ינואר',
        feb: 'פברואר',
        mar: 'מרץ',
        apr: 'אפריל',
        may: 'מאי',
        jun: 'יוני',
        jul: 'יולי',
        aug: 'אוגוסט',
        sep: 'ספטמבר',
        oct: 'אוקטובר',
        nov: 'נובמבר',
        dec: 'דצמבר',
      },
    },
    select: {
      loading: 'טוען',
      noMatch: 'לא נמצאה התאמה',
      noData: 'אין נתונים',
      placeholder: 'שומר מקום',
    },
    cascader: {
      noMatch: 'לא נמצאה התאמה',
      loading: 'טוען',
      placeholder: 'שומר מקום',
      noData: 'אין נתונים',
    },
    pagination: {
      goto: 'עבור ל',
      pagesize: '/עמוד',
      total: 'כולל {total}',
      pageClassifier: '',
    },
    messagebox: {
      title: 'הודעה',
      confirm: 'אישור',
      cancel: 'בטל',
      error: 'קלט לא תקין',
    },
    upload: {
      deleteTip: 'לחץ כדי למחוק',
      delete: 'מחק',
      preview: 'תצוגה מקדימה',
      continue: 'המשך',
    },
    table: {
      emptyText: 'אין נתונים',
      confirmFilter: 'אישור',
      resetFilter: 'נקה',
      clearFilter: 'הכל',
      sumText: 'סך הכל',
    },
    tree: {
      emptyText: 'אין נתונים',
    },
    transfer: {
      noMatch: 'לא נמצאה התאמה',
      noData: 'אין נתונים',
      titles: ['רשימה 1', 'רשימה 2'],
      filterPlaceholder: 'סנן לפי...',
      noCheckedFormat: 'פריטים {total}',
      hasCheckedFormat: ' נבחרו {checked}/{total}',
    },
    image: {
      error: 'שגיאה',
    },
    pageHeader: {
      title: 'חזרה',
    },
    popconfirm: {
      confirmButtonText: 'כן',
      cancelButtonText: 'לא',
    },
  },
}
